module.exports = "<div class=\"centerHrt\" bs-aside=\"aside\" data-container=\"body\" data-template-url=\"more-info.component.html\">\n  <a href='#' (click)=\"toggleSideTab()\">{{tabText}}</a>\n</div>"


//////////////////
// WEBPACK FOOTER
// D:/FLINK/FlinkViewingPageDec2020/NewLandingPage/src/app/sidebar/sidebar.component.html
// module id = ../../../../../src/app/sidebar/sidebar.component.html
// module chunks = 1